/* eslint-disable import/no-named-as-default */
import AppBanner from './AppBanner';

export default AppBanner;
